import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderMdx } from "@/components/content/render-mdx";
import {
  Article,
  ArticleContainer,
  ArticleDescription,
  ArticleHeader,
  ArticleHeading,
} from "@/components/primitives/article";
import { PageContainer } from "@/components/primitives/layout";

const getTermsData = createServerFn({ method: "GET" }).handler(async () => {
  const { terms } = await import("../../.velite");
  if (terms.length !== 1) {
    throw new Error("Expected exactly one terms of use document");
  }
  return terms[0];
});

export const Route = createFileRoute("/terms")({
  loader: () => getTermsData(),
  head: ({ loaderData }) => ({
    meta: [
      { title: `${loaderData?.title ?? "Terms of Use"} - Scoopulator` },
      { name: "description", content: loaderData?.description ?? "" },
    ],
  }),
  component: TermsOfUsePage,
});

function TermsOfUsePage() {
  const termsOfUse = Route.useLoaderData();

  return (
    <PageContainer>
      <ArticleContainer>
        <ArticleHeader>
          <ArticleHeading>{termsOfUse.title}</ArticleHeading>
          <ArticleDescription>
            Last updated:{" "}
            {new Date(termsOfUse.updatedAt).toLocaleDateString(undefined, {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </ArticleDescription>
        </ArticleHeader>
        <Article>{renderMdx(termsOfUse.body)}</Article>
      </ArticleContainer>
    </PageContainer>
  );
}
